import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {WalletFragment} from "../fragments/fullWallet"

const query = gql`
  query Wallet($userId: String!, $currency: String!, $entityId: ID, $entityType: WalletEntityType) {
    wallet(userId: $userId, entityId: $entityId, currency: $currency, entityType: $entityType) {
      ...WalletFragment
    }
  }

  ${WalletFragment}
`

export const walletQueryKey = getQueryNames(query)[0]

export default query
